import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AemVariableConfig } from '../../types/common.types';
import { getUrlParams } from '@wec-core/helpers';
import { getAemConfigs, getSpecialPromo } from '../../helpers/common';
import CONSTANTS from '../../constants/common';
import { navigate } from 'gatsby';
import { BaseState } from '../../types/state.types';
import { AEM_CONFIG_KEYS } from '../../config/common';
import isFeatureFlagEnabled from '../../helpers/feature-flags';
import { FEATURE_FLAG_SPECIAL_PROMO } from '../../types/featureFlag.types';
import { Plan } from '../../types/plan.types';
import { setSpecialPromo } from '../../reducers/promotions';
import { planActions } from '@detox/actions';

export const useSpecialPromo = ({
  aemVariableConfigs,
  plans
}: {
  aemVariableConfigs: AemVariableConfig[];
  plans: Plan[];
}) => {
  const dispatch = useDispatch();

  const { plan } = useSelector<BaseState, Partial<BaseState>>(state => {
    return {
      plan: state.plan
    };
  });

  const { selectedPlan } = plan;

  const [specialPromoAemData] = getAemConfigs(aemVariableConfigs, [
    AEM_CONFIG_KEYS.SPECIAL_PROMO_SALE
  ]);

  const isSpecialPromoEnabled = isFeatureFlagEnabled(
    FEATURE_FLAG_SPECIAL_PROMO
  );

  useEffect(() => {
    const urlParams = getUrlParams(window.location.search);
    const { status: isSpecialPromo, specialPromo } = getSpecialPromo({
      specialPromoAemData,
      urlParams
    });
    if (isSpecialPromoEnabled && isSpecialPromo) {
      const planRelId = urlParams[CONSTANTS.URL_PARAMS.PLAN_ID];
      const selectedPlan = plans.find(plan => plan.planRelId === planRelId);
      if (selectedPlan) {
        dispatch(setSpecialPromo(specialPromo));
        const mobileSharePromo =
          urlParams[CONSTANTS.URL_PARAMS.PROMOTE_CODE] ===
          CONSTANTS.BUNDLED_MOBILESHARE;
        dispatch(
          planActions.setSelectedPlan({
            ...selectedPlan,
            ...(mobileSharePromo && { mobileShareOrderType: 'MS_NEW' })
          })
        );
      } else {
        navigate('/', { replace: true });
      }
    } else if (!selectedPlan) {
      navigate('/', { replace: true });
    }
  }, []);
};
